module.exports = __webpack_public_path__ + "static/media/accessories3.981998d5.jpg";